import { Button, TextField, Stack, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Tooltip, IconButton, Snackbar, Paper, Box } from "@mui/material";
import React, { useState } from "react";
import { useWalletInterface } from "../services/wallets/useWalletInterface";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

function SignatureBlock({ sig }: { sig: string }) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    await navigator.clipboard.writeText(sig);
    setCopied(true);
  };

  return (
    <>
      <Paper
        variant="outlined"
        sx={{
          mt: 2,
          p: 1.5,
          width: "100%",
          maxWidth: 720,
          borderRadius: 2,
          bgcolor: "rgba(255,255,255,0.04)",
        }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography sx={{ fontSize: 14, color: "rgba(255,255,255,0.6)", fontWeight: 600 }}>
            Signature
          </Typography>

          <Tooltip title="Copy">
            <IconButton size="small" onClick={copy} sx={{ color: "rgba(255,255,255,0.8)" }}>
              <ContentCopyIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Stack>

        <Box
          component="pre"
          sx={{
            mt: 1,
            mb: 0,
            fontSize: 13,
            lineHeight: 1.5,
            fontFamily: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
            color: "rgba(255,255,255,0.9)",
            whiteSpace: "pre-wrap",
            overflowWrap: "anywhere", 
            wordBreak: "normal",
            userSelect: "text",
          }}
        >
          {sig}
        </Box>
      </Paper>

      <Snackbar
        open={copied}
        autoHideDuration={1500}
        onClose={() => setCopied(false)}
        message="Copied!"
      />
    </>
  );
}
export default function MultiSig() {
  const { walletInterface } = useWalletInterface();
  const [txBase64, setTxBase64] = useState("");
  const [successOpen, setSuccessOpen] = useState(false);
  const [sig, setSig] = useState<string|null>(null);

  const onSign = async () => {
    console.log(txBase64);
    if (!walletInterface || !txBase64) return;

    try {
      const signature = await walletInterface.getSignature(txBase64.trim());
      if (signature) {
        setSig(signature);
        setSuccessOpen(true);
      }
      console.log("Transaction signed");
    } catch (err) {
      console.error("Signing failed:", err);
    }
  };

  return (
    <Stack spacing={3} alignItems="center">
      <Typography variant="h5">
        Sign Transaction
      </Typography>

      <TextField
        label="Transaction (Base64)"
        value={txBase64}
        onChange={(e) => setTxBase64(e.target.value)}
        multiline
        minRows={3}  sx={{
          width: "100%",
          maxWidth: 700,
        }}
      />

      <Button
        variant="contained"
        onClick={onSign}
        disabled={!txBase64 || !walletInterface}
      >
        Sign
      </Button>
      <Dialog
        open={successOpen}
        onClose={() => setSuccessOpen(false)}
      >
        <DialogTitle>✅ Transaction Signed</DialogTitle>
        <DialogContent>
          <Typography>
            Your transaction was successfully signed!
          </Typography>
          {sig && <SignatureBlock sig={sig}/>}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSuccessOpen(false)} variant="contained">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Stack>
  );
}
